import { HeroCarousel } from "../components/HeroCarousel";
import { MovieRow } from "../components/MovieRow";
import { AdSlot } from "../components/AdSlot";
import { useFetch } from "../lib/useFetch";

const Row = ({ id, title, eyebrow, url, params }) => {
  const { data, loading, error, retry } = useFetch(url, params);
  return <MovieRow id={id} title={title} eyebrow={eyebrow} movies={data?.results} loading={loading} error={error} onRetry={retry} />;
};

export default function Home() {
  const today = useFetch("/movies/trending", { window: "day" });
  return (
    <div data-testid="home-page">
      <HeroCarousel movies={today.data?.results} loading={today.loading} error={today.error} onRetry={today.retry} />
      <AdSlot name="home_top" className="relative z-10" />
      <div className="relative z-10 -mt-6">
        <MovieRow id="trending-today" title="Trending Today" eyebrow="Right now" movies={today.data?.results} loading={today.loading} error={today.error} onRetry={today.retry} />
        <Row id="trending-week" title="Trending This Week" eyebrow="The week's obsessions" url="/movies/trending" params={{ window: "week" }} />
        <Row id="popular" title="Popular" eyebrow="Crowd favourites" url="/movies/popular" />
        <Row id="top-rated" title="Top Rated" eyebrow="The canon" url="/movies/top_rated" />
        <AdSlot name="home_middle" />
        <Row id="trending-tv-today" title="Trending TV Today" eyebrow="Binge-worthy now" url="/tv/trending" params={{ window: "day" }} />
        <Row id="popular-tv" title="Popular TV Series" eyebrow="Series everyone's watching" url="/tv/popular" />
      </div>
    </div>
  );
}
